import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import {
  ApproachSettingDetailsModule,
  TicketIssueGuideModule,
  ServiceModule,
  LineMessageListViewerModule,
} from '@blcloud/bl-ng-share-module';
import {
  SnsBulkSendHistoryResource,
  SnsDeliveryRequestResource,
} from '@blcloud/bl-ng-resource';

import { SnsSendMessageConfirmModalComponent } from './sns-send-message-confirm-modal.component';
import { SnsSendMessageConfirmModalService } from './sns-send-message-confirm-modal.service';

@NgModule({
  imports: [
    CommonModule,
    BlNgUiComponentModule,
    LineMessageListViewerModule.forRoot(),
    ApproachSettingDetailsModule.forRoot(),
    TicketIssueGuideModule,
    ServiceModule,
  ],
  exports: [
    SnsSendMessageConfirmModalComponent,
  ],
  declarations: [
    SnsSendMessageConfirmModalComponent,
  ],
  providers: [
    SnsDeliveryRequestResource,
    SnsBulkSendHistoryResource,
  ],
  entryComponents: [
    SnsSendMessageConfirmModalComponent,
  ]
})
export class SnsSendMessageConfirmModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SnsSendMessageConfirmModalModule,
      providers: [
        SnsDeliveryRequestResource,
        SnsSendMessageConfirmModalService,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-confirm-modal/sns-send-message-confirm-modal.module.ts